import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

// Main layouts
import LayoutBackend from "@/layouts/variations/Backend.vue";
import Home from "@/views/Home";

import ComparisonGroups from "@/views/ComparisonGroups";
import Report from "@/views/Report";

import AdminKeywords from "@/views/Admin/Keywords";
import AdminUsers from "@/views/Admin/Users";
import AdminItems from "@/views/Admin/Items";
import AdminItemData from "@/views/Admin/Items/Data";
import AdminComparisonGroupList from "@/views/Admin/ComparisonGroups/List";
import AdminComparisonGroupData from "@/views/Admin/ComparisonGroups/Data";

const routes = [
  {
    path: "/",
    name: "Home",
    component: LayoutBackend,
    children: [
      {
        path: "/",
        name: "Home",
        component: Home
      },
      {
        path: "/comparison_groups",
        name: "Vergleichsgruppen",
        component: ComparisonGroups
      },
      {
        path: "/report",
        name: "Report",
        component: Report
      },
      {
        path: "/admin",
        name: "Verwaltung",
        component: {
          render(c) {
            return c("router-view");
          }
        },
        children: [
          {
            path: "keywords",
            name: "Keywords",
            component: AdminKeywords
          },
          {
            path: "users",
            name: "User",
            component: AdminUsers
          },
          {
            path: "items",
            name: "Artikel",
            component: AdminItems
          },
          {
            path: "items/:itemId",
            name: "Artikel",
            component: AdminItemData
          },
          {
            path: "comparison_groups",
            name: "Vergleichsgruppen",
            component: AdminComparisonGroupList
          },
          {
            path: "comparison_groups/:groupId",
            name: "Vergleichsgruppe",
            component: AdminComparisonGroupData
          }
        ]
      }
    ]
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

export default router;
